import { render, staticRenderFns } from "./DesignBasePagination.vue?vue&type=template&id=0851a13a&"
import script from "./DesignBasePagination.vue?vue&type=script&lang=js&"
export * from "./DesignBasePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports